export default "__VITE_ASSET__Dsd6qZ5Y__"